import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CUSTOMERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('CUSTOMERS');
export const CUSTOMERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CUSTOMERS_CRUD_ACTION_CONSTANTS
);
